export default __webpack_public_path__ + "static/media/estoque.6f5f3d61.png";